import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    isSupported: boolean;

    constructor() {
        try {
            localStorage.getItem('a');
            this.isSupported = true;
        } catch (e) {
            this.logNotSupportedInfo();
            this.isSupported = false;
        }
    }

    setItem(key: string, value: string) {
        if (this.isSupported) {
            localStorage.setItem(key, value);
        }
    }

    getItem(key: string) {
        return this.isSupported ? localStorage.getItem(key) : null;
    }

    private logNotSupportedInfo() {
        console.log('Local storage is not supported');
    }
}
